import axios from "axios";
import AxiosClient from "../../../services/axios.services";

class ApproachesServices {
  getApproaches = params =>
    AxiosClient.get("/api/app/capacitacion_enfoque/", {
      headers: { "Content-Type": "application/json" },
      params: params,
   });
  getApproach = id =>
    AxiosClient.get(`/api/app/capacitacion_enfoque/${id}/`, {
      headers: { "Content-Type": "application/json" },
    });
  saveApproaches = data =>
    AxiosClient.post("/api/app/capacitacion_enfoque/", data, {
      headers: { "Content-Type": "application/json" },
    });
  editApproaches = (id, data) =>
    AxiosClient.put(
      `/api/app/capacitacion_enfoque/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  deleteApproaches = id =>
    AxiosClient.delete(`/api/app/capacitacion_enfoque/${id}`, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new ApproachesServices();